import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from "@/contexts/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";
import { startKeepAlive, stopKeepAlive } from "@/services/keepAlive";
import Home from "@/pages/Home";
import About from "@/pages/About";
import PracticeAreas from "@/pages/PracticeAreas";
import CaseStudies from "@/pages/CaseStudies";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Sectors from "@/pages/Sectors";
import Careers from "@/pages/Careers";
import CareerApply from "@/pages/CareerApply";
import SocialResponsibility from "@/pages/SocialResponsibility";
import FAQ from "@/pages/FAQ";
import Locations from "@/pages/Locations";
import Contact from "@/pages/Contact";
import ClientLogin from "@/pages/ClientLogin";
import SolicitorLogin from "@/pages/SolicitorLogin";
import TermsOfEngagement from "@/pages/TermsOfEngagement";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import CodeOfConduct from "@/pages/CodeOfConduct";
import AdminDashboard from "@/pages/AdminDashboard";
import ClientDashboard from "@/pages/ClientDashboard";
import SolicitorDashboard from "@/pages/SolicitorDashboard";
import ComingSoon from "@/pages/ComingSoon";

function App() {
  // Start keep-alive service when app mounts
  useEffect(() => {
    startKeepAlive();
    
    return () => {
      stopKeepAlive();
    };
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <Navbar />
            <Routes>
            {/* Coming Soon Page - Standalone */}
            <Route path="/coming-soon" element={<ComingSoon />} />
            
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/practice-areas" element={<PracticeAreas />} />
            <Route path="/sectors" element={<Sectors />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:id" element={<InsightDetail />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/apply" element={<CareerApply />} />
            <Route path="/social-responsibility" element={<SocialResponsibility />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* Legal Pages */}
            <Route path="/terms-of-engagement" element={<TermsOfEngagement />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/code-of-conduct" element={<CodeOfConduct />} />
            
            {/* Auth Routes */}
            <Route path="/client-login" element={<ClientLogin />} />
            <Route path="/solicitor-login" element={<SolicitorLogin />} />
            
            {/* Protected Routes - Admin Only */}
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin-dashboard" 
              element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* Protected Routes - Client */}
            <Route 
              path="/client-dashboard" 
              element={
                <ProtectedRoute allowedRoles={['client']}>
                  <ClientDashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* Protected Routes - Solicitor */}
            <Route 
              path="/solicitor-dashboard" 
              element={
                <ProtectedRoute allowedRoles={['solicitor']}>
                  <SolicitorDashboard />
                </ProtectedRoute>
              } 
            />
          </Routes>
          <Footer />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
